/* ============================================================================
   CUSTOM: PRODUCT SET TABS (v2)
   セット商品の疑似バリアント切り替え。ピル（文字）とサムネ（画像）の両方が
   [data-tab] を持ち、押すと:
     1. パネル（画像・タイトル・価格・説明）を切り替え
     2. ピル・サムネ両方の選択状態を同期
     3. 単一フォームの hidden id（バリアントID）とボタン状態を差し替え
     4. アドレスバーを選択中セットのURLに置換（テーマエディタ内では行わない）
   素の JS（IIFE）。ライブラリ非依存。customizer 再描画にも追従する。
   ============================================================================ */
(function () {
  function initSetTabs(root) {
    if (!root || root.dataset.tabsInit === 'true') return;

    var switches = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pane]'));
    if (!switches.length || !panels.length) return;

    function activate(index) {
      switches.forEach(function (sw) {
        var isMatch = sw.getAttribute('data-tab') === index;
        sw.classList.toggle('is-selected', isMatch);
        sw.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
      });

      var dataPane = null;
      panels.forEach(function (panel) {
        var isMatch = panel.getAttribute('data-pane') === index;
        panel.classList.toggle('is-active', isMatch);
        if (isMatch) {
          panel.removeAttribute('hidden');
          if (panel.hasAttribute('data-variant-id')) dataPane = panel;
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      if (!dataPane) return;

      // 単一フォームの中身（バリアントID・ボタン状態）を選択中セットに差し替える
      var form = document.getElementById(root.dataset.formId);
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = dataPane.getAttribute('data-variant-id');

        var submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
          var available = dataPane.getAttribute('data-available') === 'true';
          submitButton.disabled = !available;
          var label = available ? root.dataset.labelAdd : root.dataset.labelSoldout;
          if (label) submitButton.textContent = label;
        }
      }

      // アドレスバーを選択中セットのURLに置換（履歴は積まない）。エディタ内では触らない
      var url = dataPane.getAttribute('data-product-url');
      if (url && !(window.Shopify && window.Shopify.designMode)) {
        try {
          // 流入時のクエリ（?utm_... 等）とハッシュは温存してパスだけ置き換える
          window.history.replaceState(null, '', url + window.location.search + window.location.hash);
        } catch (e) {
          /* 置換できない環境ではそのまま（切替自体は成立している） */
        }
      }
    }

    switches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        activate(sw.getAttribute('data-tab'));
      });
    });

    root.activatePane = activate;
    root.dataset.tabsInit = 'true';
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var roots = container.querySelectorAll('[data-product-set-tabs]');
    Array.prototype.forEach.call(roots, function (root) {
      initSetTabs(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // customizer でセクションを読み込み・並べ替えた際に再初期化
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:reorder', function (event) {
    initAll(event.target);
  });
})();
